import React from 'react';
import { Chip } from '@mui/material';
import {
  getTodayCalendarYmd,
  isCalendarDateBefore,
} from '../../../../utils/calendarDate';

/**
 * Schedule status chip for the Work Package Progress table.
 *
 * Displays:
 *   - Green "On track"  when today ≤ planned finish date
 *   - Red   "Overrun"   when today > planned finish date AND the lane is not complete
 *   - Nothing (null)    when planned finish is null / undefined
 *
 * Pass field planned finish + field completion for the field anchor lane, or
 * shop planned finish + shop completion for the prefab lane.
 *
 * Props
 * ─────
 * plannedFinishDate   string|null  ISO date (e.g. planned_field_finish or planned_shop_finish)
 * isComplete          bool         true when this lane is finished (field or shop actual finish)
 */
const ScheduleChip = ({ plannedFinishDate, isComplete = false }) => {
  if (!plannedFinishDate) return null;

  // Compare calendar days, not timestamps — new Date(plannedFinishDate) on a
  // date-only / UTC-midnight value lands on the previous day in US timezones.
  // Completed packages are done — never show overrun
  const isOverrun =
    !isComplete &&
    isCalendarDateBefore(plannedFinishDate, getTodayCalendarYmd());

  if (isOverrun) {
    return (
      <Chip
        label="Overrun"
        size="small"
        sx={{
          fontSize: '11px',
          fontWeight: 600,
          height: 22,
          bgcolor: '#FDECEC',
          color: '#B91C1C',
          border: '1px solid #FECACA',
          '& .MuiChip-label': { px: 1 },
        }}
      />
    );
  }

  return (
    <Chip
      label="On track"
      size="small"
      sx={{
        fontSize: '11px',
        fontWeight: 600,
        height: 22,
        bgcolor: '#ECFDF5',
        color: '#0F6E56',
        border: '1px solid #BBF7D0',
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
};

export default ScheduleChip;
